/* RW bundle selector (Buy 1 to Buy 4) for the product page. Markup: snippets/rw-bundle-tiers.liquid. Data: sections/rw-bundle-data.liquid.
   - Buy 1 leaves the theme's own add-to-cart flow completely alone.
   - Buy 2+ adds one line per colour and size through the theme's cart library (_rw.CartFox), so the cart drawer behaves as usual.
   - Colours are separate products. Every item, including item 1, picks from the colour family without leaving the page;
     item 1 simply starts as this page's colour.
   - Each row's size follows the main size buttons until it is changed on that row.
   - A few styles have a second option next to Size (NKD Wide Leg: Fit = Regular / Tall). Each row then also carries a fit,
     flipped with one tap on the left half of its pill; it follows the main fit buttons the same way.
   - Display and add-to-cart only: the discount itself is applied by Shopify, outside the theme.
   - Optional A/B split (section setting bundle_ab_split): group B visitors get the normal product page; see the block after track(). */
(function () {
  'use strict';
  var root = document.getElementById('RwBundle'), cfgEl = document.getElementById('RwBundleConfig'), form = document.getElementById('AddToCartForm');
  if (!root || !cfgEl || !form || root.getAttribute('data-ready')) return;
  root.setAttribute('data-ready', '1');
  var cfg, page;
  try { cfg = JSON.parse(cfgEl.textContent); page = JSON.parse(document.getElementById('ProductJson').textContent); } catch (e) { return; }

  var $id = function (id) { return document.getElementById(id); };
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  // Events go to GA4 through the gtag that Shopify's Google app already loads on the page (there is no Tag Manager, so a plain
  // dataLayer object is ignored). gtag can arrive after this script, so events wait in a short queue until its GA4 config is seen.
  var gaQueue = [], gaTimer = null;
  function gaId() { var dl = window.dataLayer || []; for (var i = 0; i < dl.length; i++) { var e = dl[i]; if (e && e[0] === 'config' && /^G-/.test(String(e[1]))) return e[1]; } return null; }
  function gaFlush() {
    var id = gaId(); if (!id || typeof window.gtag !== 'function') return false;
    gaQueue.splice(0).forEach(function (x) { x[1].send_to = id; window.gtag('event', x[0], x[1]); }); return true;
  }
  var track = function (name, data) {
    try {
      var params = Object.assign({ rw_bundle_handle: page.handle, rw_group: AB }, data || {});
      (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, params));
      gaQueue.push([name, params]);
      if (!gaFlush() && !gaTimer) { var tries = 0; gaTimer = setInterval(function () { if (gaFlush() || ++tries > 40) { clearInterval(gaTimer); gaTimer = null; } }, 500); }
    } catch (e) {}
  };

  // ---- A/B split (section setting "Split test"). The snippet's inline script has already put this visitor in a group:
  //      'A' or 'B' (random, new visitors), 'A0' (had seen the bundle before the split), 'off' (split switched off).
  //      Group B gets the theme's normal product page: nothing after this block runs, the cards stay hidden, the quantity box shows,
  //      and the cart is only tagged _rw_ab = B. B never gets the deal flag (_rw_bundle), so the discount cannot apply. ----
  var AB = document.documentElement.getAttribute('data-rw-ab') || 'off';
  var cookieAB = function (g) { try { document.cookie = 'rw_ab=' + g + ';path=/;max-age=' + (60 * 86400) + ';samesite=lax'; } catch (e) {} };
  function readCart() { return fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function setAttrs(a) { return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }) }); }
  if (AB !== 'off') { track('rw_ab_page', {}); track('rw_ab_page_' + AB, {}); }   // the per-group name shows in GA4's standard Events report without a custom dimension
  if (AB === 'B') {
    // Same care as the deal flag below: a brand-new visitor's cart can be replaced by another script's request, so read back and repair.
    var bBusy = null, bJq = false;
    var ensureB = function () {
      if (bBusy) return bBusy;
      var tries = 0;
      var attempt = function () {
        return readCart().then(function (c) {
          var at = (c && c.attributes) || {};
          if (at._rw_bundle === '1' && at._rw_ab !== 'A0') {   // a cart flagged before the split: this shopper has seen the bundle, keep it for them from the next page on
            AB = 'A0'; cookieAB('A0'); return setAttrs({ _rw_ab: 'A0' }).then(function () { return true; });
          }
          if (at._rw_ab === AB) return true;
          if (++tries > 4) return false;
          return setAttrs({ _rw_ab: AB }).then(function () { return new Promise(function (res) { setTimeout(res, 900); }); }).then(attempt);
        });
      };
      bBusy = attempt().catch(function () { return false; }).then(function (ok) { bBusy = null; return ok; });
      return bBusy;
    };
    var bindB = function () { var jq = window.jQuery; if (bJq || !jq) return; bJq = true; jq(document).on('cartfox:itemAdded cartfox:cartUpdated', function () { setTimeout(ensureB, 300); }); };
    document.addEventListener('DOMContentLoaded', bindB); window.addEventListener('load', bindB);
    ensureB();
    return;
  }

  // ---- This page's product, from the ProductJson the theme already prints ----
  function hexFromTags(tags) { for (var i = 0; i < tags.length; i++) { var m = /^swatch-(#[0-9a-f]{3,8})$/i.exec(String(tags[i]).trim()); if (m) return m[1]; } return '#d9d9d9'; }
  function sized(src, w) { if (!src) return ''; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var OPTS = (page.options || []).map(function (o) { return String(o && o.name ? o.name : o).trim(); });
  var SIZE_POS = 0; OPTS.forEach(function (n, k) { if (/^size$/i.test(n)) SIZE_POS = k; });
  var HAS_FIT = OPTS.length === 2, FIT_POS = HAS_FIT ? 1 - SIZE_POS : -1, FIT_NAME = HAS_FIT ? OPTS[FIT_POS] : '', FIT_WORD = FIT_NAME.toLowerCase();
  function uniq(list) { var out = []; list.forEach(function (x) { if (x != null && out.indexOf(x) < 0) out.push(x); }); return out; }
  var optEl = document.querySelector('.product-option p');
  var me = {
    id: page.id, handle: page.handle, name: (optEl && optEl.textContent.trim()) || page.title, img: sized(page.featured_image, 200),
    hex: hexFromTags(page.tags || []), price: page.price, compare: page.compare_at_price || 0, tags: (page.tags || []).join(','),
    variants: (page.variants || []).map(function (v) { return { id: v.id, size: v['option' + (SIZE_POS + 1)], fit: HAS_FIT ? v['option' + (FIT_POS + 1)] : null, ok: v.available }; })
  };
  var SIZES = uniq(me.variants.map(function (v) { return v.size; })), FITS = uniq(me.variants.map(function (v) { return v.fit; }));
  var family = [me], byId = {}; byId[me.id] = me;

  var state = { qty: 1, size: null, fit: null, open: null, items: [{ c: me.id, s: null, f: null }], loaded: false, loading: false, adding: false };

  // ---- Prices (cents). A colour already on sale keeps its sale price unless stacking is switched on; it still counts as an item. ----
  function onSale(it) { return it.compare > it.price; }
  // Same maths as Shopify: the discount per unit is rounded DOWN to the cent, then multiplied by the quantity.
  function discounted(it, pct) { return (!cfg.stackOnSale && onSale(it)) ? it.price : it.price - Math.floor(it.price * pct / 100); }
  function tier(q) { for (var i = 0; i < cfg.tiers.length; i++) if (cfg.tiers[i].qty === q) return cfg.tiers[i]; return cfg.tiers[0]; }
  function basket() {
    var pct = tier(state.qty).pct, full = 0, total = 0;
    state.items.forEach(function (x) { var it = byId[x.c] || me; full += it.price; total += discounted(it, pct); });
    return { full: full, total: total, save: full - total };
  }
  function sizeOf(i) { var x = state.items[i]; return (cfg.sizePerItem && i > 0 && x.s) ? x.s : state.size; }
  function fitOf(i) { if (!HAS_FIT) return null; var x = state.items[i]; return (cfg.sizePerItem && i > 0 && x.f) ? x.f : state.fit; }
  function variantFor(it, size, fit) { for (var i = 0; i < it.variants.length; i++) { var v = it.variants[i]; if (v.size === size && (!HAS_FIT || v.fit === fit)) return v; } return null; }
  function isOut(it, size, fit) {
    if (!size) return false;
    if (HAS_FIT && !fit) return !it.variants.some(function (v) { return v.size === size && v.ok; });   // no fit picked yet: out only if every fit is
    var v = variantFor(it, size, fit); return !v || !v.ok;
  }
  function optLabel(size, fit) { return (HAS_FIT && fit ? fit + ' ' : '') + (size || ''); }               // "Tall M"
  function fitShort(f) { return f ? (f.length > 4 ? f.slice(0, 3) : f) : FIT_NAME; }                       // "Reg", "Tall"

  // ---- Colour family, one request, on demand (prefetched when the browser is idle) ----
  var waiters = [];
  function ensureData(cb) {
    if (state.loaded) { if (cb) cb(); return; }
    if (cb) waiters.push(cb);
    if (state.loading) return; state.loading = true;
    fetch(cfg.dataUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rw-bundle-data]');
      var items = el ? JSON.parse(el.textContent).items : [];
      items.forEach(function (it) {
        var fitted = !!(it.variants && it.variants[0] && it.variants[0].fit != null);                       // same option layout as this page only
        if (it.id !== me.id && fitted === HAS_FIT) { it.hex = it.hex || '#d9d9d9'; family.push(it); byId[it.id] = it; }
      });
    }).catch(function () { /* the selector still works with this page's colour only */ }).then(function () {
      state.loaded = true; state.loading = false; render();
      waiters.splice(0).forEach(function (fn) { fn(); });
    });
  }

  // ---- Tier cards ----
  var TICK = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1.5 6.5l3 3 6-7"/></svg>';
  function renderTiers() {
    var b = basket(), html = '';
    cfg.tiers.forEach(function (t) {
      var on = t.qty === state.qty, eachC = discounted(me, t.pct), total = on ? b.total : eachC * t.qty;
      var best = t.qty === cfg.best;
      html += '<div class="rwb-tier-wrap' + (best ? ' has-badge' : '') + '"><button type="button" class="rwb-tier' + (on ? ' is-selected' : '') + '" role="radio" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '" data-qty="' + t.qty + '">' +
        (best ? '<span class="rwb-vh">Best value. </span>' : '') +
        '<span class="rwb-tier__buy">Buy ' + t.qty + '</span>' +
        '<span class="rwb-tier__price">' + money(eachC) + '</span><span class="rwb-tier__each">each</span><span class="rwb-tier__rule" aria-hidden="true"></span>' +
        (t.pct > 0 ? '<span class="rwb-tier__save">Save ' + t.pct + '%</span>' : '<span class="rwb-tier__save is-none">Full price</span>') +
        '<span class="rwb-tier__total">' + money(total) + ' total</span>' +
        (cfg.freeShipFrom > 0 && total >= cfg.freeShipFrom ? '<span class="rwb-tier__ship">' + TICK + 'Free shipping</span>' : '') + '</button>' +
        (best ? '<span class="rwb-tier__badge" aria-hidden="true">Best value</span>' : '') + '</div>';
    });
    $id('RwbTiers').innerHTML = html;
  }
  function setQty(q, focus) {
    if (q === state.qty) return;
    state.qty = q; state.open = null;
    while (state.items.length < q) state.items.push({ c: me.id, s: null, f: null });
    state.items.length = q;
    if (q === 1) state.items[0].c = me.id;   // Buy 1 is the theme's own flow, which adds this page's product
    if (q > 1) ensureData();
    render(); track('rw_bundle_tier', { rw_bundle_qty: q });
    if (focus) { var sel = $id('RwbTiers').querySelector('.is-selected'); if (sel) sel.focus({ preventScroll: true }); }
  }

  // ---- Item rows ----
  var CHEV = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 4.5l4 4 4-4"/></svg>';
  var SWAP = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 4h7.5M7.5 1.8L9.7 4 7.5 6.2M10 8H2.5M4.5 5.8L2.3 8l2.2 2.2"/></svg>';
  var ARROW_L = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.5 2l-4 4 4 4"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 2l4 4-4 4"/></svg>';
  function renderItems() {
    var box = $id('RwbItems'); box.hidden = state.qty < 2; if (state.qty < 2) { state.open = null; return; }
    box.classList.toggle('no-size', !cfg.sizePerItem);
    $id('RwbItemsTitle').textContent = cfg.sizePerItem ? 'Your ' + state.qty + ' items' : 'Choose your ' + state.qty + ' colours';
    var need = !state.size || (HAS_FIT && !state.fit);
    var mixS = state.items.some(function (_, i) { return sizeOf(i) !== sizeOf(0); }), mixF = HAS_FIT && state.items.some(function (_, i) { return fitOf(i) !== fitOf(0); });
    $id('RwbSizeNote').textContent = need ? (HAS_FIT ? 'Pick a ' + FIT_WORD + ' and size above' : 'Pick a size above') : (mixS && mixF) ? 'Mixed ' + FIT_WORD + 's and sizes' : mixF ? 'Mixed ' + FIT_WORD + 's' : mixS ? 'Mixed sizes' : 'All in ' + (HAS_FIT ? state.fit + ', size ' + state.size : 'size ' + state.size);
    var rows = $id('RwbItemRows'), pct = tier(state.qty).pct, html = '', keep = {};
    each(rows.querySelectorAll('.rwb-strip__track'), function (t) { keep[t.getAttribute('data-i')] = t.scrollLeft; });
    state.items.forEach(function (x, i) {
      var it = byId[x.c] || me, now = discounted(it, pct), sz = sizeOf(i), ft = fitOf(i), n = i + 1, open = state.open && state.open.i === i;
      var was = onSale(it) ? it.compare : it.price;
      html += '<div class="rwb-item" data-i="' + i + '">' +
        '<span class="rwb-item__pic"><img alt="" loading="lazy" src="' + esc(it.img) + '"><i>' + n + '</i></span>' +
        '<div class="rwb-item__main"><div class="rwb-item__top">' +
          '<span class="rwb-item__name" data-name>' + esc(it.name) + '</span>' +
          (cfg.sizePerItem
            ? '<div class="rwb-item__size"><div class="rwb-duo">' +
                (HAS_FIT ? '<button type="button" class="rwb-pill rwb-pill--fit' + (ft ? '' : ' is-empty') + '" data-flip="fit" title="' + esc(ft || FIT_NAME) + '" aria-label="Item ' + n + ' ' + esc(FIT_WORD) + (ft ? ', ' + esc(ft) : '') + '. Tap to change">' +
                  '<span>' + esc(fitShort(ft)) + '</span>' + SWAP + '</button>' : '') +
                '<button type="button" class="rwb-pill' + (sz ? '' : ' is-empty') + '" data-open="size" aria-haspopup="true" aria-expanded="' + !!open + '" aria-label="Item ' + n + ' size' + (sz ? ', ' + esc(sz) : '') + '">' +
                '<span>' + esc(sz || 'Size') + '</span>' + CHEV + '</button></div>' +
                (open
                  ? '<div class="rwb-pop"><div class="rwb-pop__sizes" role="radiogroup" aria-label="Size for item ' + n + '">' +
                      SIZES.map(function (s) {
                        var out = isOut(it, s, ft);
                        return '<button type="button" class="rwb-mini' + (s === sz ? ' is-selected' : '') + (out ? ' is-out' : '') + '" role="radio" aria-checked="' + (s === sz) + '"' + (out ? ' aria-disabled="true" title="Sold out"' : '') + ' data-size="' + esc(s) + '">' + esc(s) + '</button>';
                      }).join('') + '</div>' +
                      (i > 0 ? '<p class="rwb-pop__note">Follows the size you pick above until you change it here.</p>' : '') + '</div>'
                  : '') +
              '</div>'
            : '') +
          '<span class="rwb-item__price">' + money(now) + (now < was ? '<del>' + money(was) + '</del>' : '') + '</span>' +
        '</div>' +
        (isOut(it, sz, ft) ? '<p class="rwb-item__flag is-error">' + esc(it.name) + ' is sold out in ' + esc(optLabel(sz, ft)) + '. Pick another colour' + (HAS_FIT ? ', ' + esc(FIT_WORD) : '') + ' or size.</p>'
          : (!cfg.stackOnSale && onSale(it) ? '<p class="rwb-item__flag">Sale price, counts towards your bundle</p>' : '')) +
        (true
          ? (state.loaded
              ? '<div class="rwb-strip"><button type="button" class="rwb-strip__nav rwb-strip__nav--l" data-dir="-1" tabindex="-1" aria-hidden="true">' + ARROW_L + '</button>' +
                '<div class="rwb-strip__track" data-i="' + i + '" role="radiogroup" aria-label="Colour for item ' + n + '">' +
                family.map(function (o) {
                  var out = isOut(o, sz, ft), on = o.id === it.id;
                  return '<button type="button" class="rwb-dot' + (on ? ' is-selected' : '') + (out ? ' is-out' : '') + '" role="radio" aria-checked="' + on + '" tabindex="' + (on ? 0 : -1) + '"' + (out ? ' aria-disabled="true"' : '') +
                    ' title="' + esc(o.name) + (out ? ', sold out in ' + esc(optLabel(sz, ft)) : '') + '" aria-label="' + esc(o.name) + '" data-id="' + o.id + '" style="background:' + esc(o.hex) + '"></button>';
                }).join('') + '</div>' +
                '<button type="button" class="rwb-strip__nav rwb-strip__nav--r" data-dir="1" tabindex="-1" aria-hidden="true">' + ARROW_R + '</button></div>'
              : '<div class="rwb-item__flag">Loading colours...</div>')
          : '') +
        '</div></div>';
    });
    rows.innerHTML = html;
    each(rows.querySelectorAll('.rwb-strip__track'), function (t) {
      var k = t.getAttribute('data-i'); if (keep[k] != null) t.scrollLeft = keep[k];
      revealSelected(t); updateStrip(t);
    });
  }
  function revealSelected(t) {
    var d = t.querySelector('.is-selected'); if (!d) return;
    if (d.offsetLeft < t.scrollLeft + 30) t.scrollLeft = Math.max(0, d.offsetLeft - 30);
    else if (d.offsetLeft + d.offsetWidth > t.scrollLeft + t.clientWidth - 44) t.scrollLeft = d.offsetLeft + d.offsetWidth - t.clientWidth + 44;
  }
  function updateStrip(t) {
    var max = t.scrollWidth - t.clientWidth;
    t.parentNode.classList.toggle('can-left', t.scrollLeft > 2); t.parentNode.classList.toggle('can-right', t.scrollLeft < max - 2);
  }
  function rowEl(i) { return $id('RwbItemRows').children[i]; }
  function focusPill(i) { var r = rowEl(i), b = r && r.querySelector('[data-open="size"]'); if (b) b.focus({ preventScroll: true }); }
  function focusInPop(i) { var r = rowEl(i), t = r && (r.querySelector('.rwb-pop .is-selected:not(.is-out)') || r.querySelector('.rwb-pop button:not(.is-out)')); if (t) t.focus({ preventScroll: true }); }
  function pickColour(i, id) {
    state.items[i].c = id; state.open = null; render();
    var b = rowEl(i) && rowEl(i).querySelector('.rwb-dot.is-selected'); if (b) b.focus({ preventScroll: true });
    track('rw_bundle_colour', { rw_bundle_item: i + 1 });
  }

  // ---- Labels outside the selector: add-to-cart buttons, pay-later amounts ----
  var atcTargets = [];
  ['#AddToCartText', '#floatingATCBar button > span'].forEach(function (sel) {
    var el = document.querySelector(sel); if (!el) return;
    var icon = el.querySelector('.icon'); atcTargets.push({ el: el, original: el.innerHTML, icon: icon ? icon.outerHTML + ' ' : '' });
  });
  function setOutside() {
    var b = basket();
    atcTargets.forEach(function (t) {
      if (state.adding) return;
      t.el.innerHTML = state.qty > 1 ? t.icon + 'Add ' + state.qty + ' to cart <span class="rwb-atc-sep">|</span> ' + money(b.total) : t.original;
    });
    each(document.querySelectorAll('#ryderwear_afterpay strong .money'), function (el) { el.textContent = money(Math.floor(b.total / 4)) + ' AUD'; });
  }

  function render() {
    renderTiers(); renderItems();
    var b = basket(), s = $id('RwbSummary');
    $id('RwbQty').textContent = state.qty + (state.qty === 1 ? ' item' : ' items');
    s.hidden = state.qty < 2;
    if (state.qty > 1) s.innerHTML = '<b>' + state.qty + ' items</b> for <b>' + money(b.total) + '</b>' + (b.save > 0 ? '. You save <b>' + money(b.save) + '</b>' : '') + (cfg.freeShipFrom > 0 && b.total >= cfg.freeShipFrom ? ', plus free shipping.' : '.');
    setOutside(); hintUpdate();
  }

  // ---- Main size: owned by the theme's size buttons; this only reads it, or clicks the theme's own button to change it ----
  function themeOpt(pos) {
    var r = form.querySelector('input.single-option-selector[data-index="option' + (pos + 1) + '"]:checked');
    if (!r && !HAS_FIT) r = form.querySelector('input.single-option-selector:checked');
    return r ? r.value : null;
  }
  function syncSize() {
    var x = themeOpt(SIZE_POS), f = HAS_FIT ? themeOpt(FIT_POS) : null; if (x === state.size && f === state.fit) return;
    state.size = x; state.fit = f; each(document.querySelectorAll('.rwb-size-error'), function (err) { err.remove(); });
    state.items.forEach(function (row, i) {
      if (i === 0) return;
      if (row.s === x) row.s = null;                                   // same as the main size again, so it follows it
      if (row.f === f) row.f = null;
    });
    render();                                                          // a colour sold out in the new size keeps its row and gets a red flag
  }
  function setThemeOpt(pos, x) {
    var input = null; each(form.querySelectorAll('input.single-option-selector'), function (r) { var di = r.getAttribute('data-index'); if (r.value === x && (!di || di === 'option' + (pos + 1))) input = r; });
    if (input && !input.classList.contains('disabled')) input.click();
  }
  form.addEventListener('change', function (e) { if (e.target && e.target.classList && e.target.classList.contains('single-option-selector')) setTimeout(syncSize, 0); });
  // The theme's jQuery (vendor.js) is deferred and runs after this file, so its events are bound once the document is ready.
  var jqBound = false;
  function bindJq() {
    var jq = window.jQuery; if (jqBound || !jq) return; jqBound = true;
    jq(document).on('variantChange', function () { setTimeout(syncSize, 0); });
    jq(document).on('cartfox:requestComplete cartfox:requestError', function () { if (state.adding) { state.adding = false; setOutside(); } });
    jq(document).on('cartfox:itemAdded cartfox:cartUpdated', function () { setTimeout(ensureGate, 300); });   // a new cart made by an add keeps the flag
    jq(document).on('cartfox:cannotAddToCart', function () {
      if (!state.adding) return; state.adding = false; setOutside();
      var er = $id('RwbError'); er.textContent = 'Some items could not be added. Please check your cart.'; er.hidden = false;
    });
    syncSize();
  }
  document.addEventListener('DOMContentLoaded', bindJq); window.addEventListener('load', bindJq);

  // ---- The discount only applies to carts that carry this attribute, so only shoppers who were shown the selector get it.
  //      A brand-new visitor has no cart yet, and another script on the page can create one at the same moment this does: two carts
  //      are made and whichever reply lands last owns the cart cookie (seen live 2026-09-23). So the flag is never assumed: it is read
  //      back, set again if missing, confirmed, and checked again after every cart change on this page. ----
  //      With the split on, the same write also records the visitor's group (_rw_ab = A or A0) for the read. ----
  var gateBusy = null;
  function gateAttrs() { var a = { _rw_bundle: '1' }; if (AB !== 'off') a._rw_ab = AB; return a; }
  function gateOk(at) { return at._rw_bundle === '1' && (AB === 'off' || at._rw_ab === AB); }
  function ensureGate() {
    if (gateBusy) return gateBusy;
    var tries = 0;
    function attempt() {
      return readCart().then(function (c) {
        if (c && c.attributes && gateOk(c.attributes)) return true;
        if (++tries > 4) return false;
        return setAttrs(gateAttrs()).then(function () { return new Promise(function (res) { setTimeout(res, 900); }); }).then(attempt);   // read back after the other reply has landed
      });
    }
    gateBusy = attempt().catch(function () { return false; }).then(function (ok) { gateBusy = null; return ok; });
    return gateBusy;
  }

  // ---- Add to cart for Buy 2+ (Buy 1 never reaches this) ----
  function showSizeError() {
    var pos = (HAS_FIT && !state.fit) ? FIT_POS : SIZE_POS, word = pos === SIZE_POS ? 'size' : FIT_WORD;
    var block = form.querySelector('input.single-option-selector[data-index="option' + (pos + 1) + '"]') || form.querySelector('input.single-option-selector'); block = block && block.closest('.variant-option'); if (!block) return;
    if (!block.querySelector('.rwb-size-error')) { var p = document.createElement('p'); p.className = 'rwb-size-error'; p.textContent = 'Please select a ' + word + ' first.'; block.appendChild(p); }
    block.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function bundleAdd() {
    if (state.adding) return;
    $id('RwbError').hidden = true;
    if (!state.loaded) { ensureData(bundleAdd); return; }
    if (!state.size || (HAS_FIT && !state.fit)) { showSizeError(); return; }
    var lines = {}, bad = false;
    state.items.forEach(function (x, i) {
      var it = byId[x.c] || me, sz = sizeOf(i), v = variantFor(it, sz, fitOf(i));
      if (!v || !v.ok) { bad = true; return; }
      if (!lines[v.id]) lines[v.id] = { qty: 0, it: it }; lines[v.id].qty += 1;
    });
    if (bad) { renderItems(); var flag = root.querySelector('.rwb-item__flag.is-error'); if (flag) flag.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
    var b = basket(), ids = Object.keys(lines);
    track('rw_bundle_add', { rw_bundle_qty: state.qty, rw_bundle_value: b.total / 100, rw_bundle_colours: ids.length });
    var cart = window._rw && window._rw.CartFox;
    if (cart && typeof cart.addItem === 'function') {
      state.adding = true; atcTargets.forEach(function (t) { t.el.textContent = (cart.options && cart.options.adding) || 'Adding...'; });
      ensureGate().then(function () {
        ids.forEach(function (id) { cart.addItem(Number(id), lines[id].qty, { _tag: lines[id].it.tags, _compare: lines[id].it.compare || '', _bundle: 'buy' + state.qty }); });
      });
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: Number(id), quantity: lines[id].qty, properties: { _bundle: 'buy' + state.qty } }; }) }) })
        .then(function () { window.location.href = '/cart'; });
    }
  }
  // Capture phase, so the theme's own delegated handler never sees the click while a bundle is selected.
  document.addEventListener('click', function (e) {
    if (state.qty < 2 || !e.target.closest) return;
    if (!e.target.closest('#MainATCButton, #floatingATCBar button')) return;
    e.preventDefault(); e.stopImmediatePropagation(); bundleAdd();
  }, true);

  // ---- Events inside the selector ----
  var tiersEl = $id('RwbTiers'), rows = $id('RwbItemRows'), drag = null, suppressClick = false;
  tiersEl.addEventListener('click', function (e) {
    var w = e.target.closest('.rwb-tier-wrap'), b = w && w.querySelector('.rwb-tier');   // the cap above the card counts as the card
    if (b) setQty(+b.getAttribute('data-qty'), true);
  });
  tiersEl.addEventListener('keydown', function (e) {
    var b = e.target.closest('.rwb-tier'); if (!b) return;
    var d = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0; if (!d) return;
    e.preventDefault(); var qs = cfg.tiers.map(function (t) { return t.qty; }), k = (qs.indexOf(state.qty) + d + qs.length) % qs.length; setQty(qs[k], true);
  });
  rows.addEventListener('click', function (e) {
    if (suppressClick) return;
    var row = e.target.closest('.rwb-item'); if (!row) return; var i = +row.getAttribute('data-i');
    var nav = e.target.closest('.rwb-strip__nav'), opener = e.target.closest('[data-open]'), dot = e.target.closest('.rwb-dot'), mini = e.target.closest('.rwb-mini'), flip = e.target.closest('[data-flip]');
    if (nav) {
      var t = row.querySelector('.rwb-strip__track'); t.scrollBy({ left: +nav.getAttribute('data-dir') * Math.round(t.clientWidth * 0.7), behavior: 'smooth' });
    } else if (flip) {
      var nx = FITS[(FITS.indexOf(fitOf(i)) + 1) % FITS.length]; state.open = null;                           // one tap: Regular -> Tall -> Regular
      if (i === 0) { renderItems(); setThemeOpt(FIT_POS, nx); } else { state.items[i].f = (nx === state.fit) ? null : nx; render(); }
      var fb = rowEl(i) && rowEl(i).querySelector('[data-flip]'); if (fb) fb.focus({ preventScroll: true });
      track('rw_bundle_fit', { rw_bundle_item: i + 1 });
    } else if (opener) {
      state.open = (state.open && state.open.i === i) ? null : { i: i }; renderItems();
      if (state.open) focusInPop(i); else focusPill(i);
    } else if (dot) {
      if (!dot.classList.contains('is-out')) pickColour(i, +dot.getAttribute('data-id'));
    } else if (mini) {
      if (mini.classList.contains('is-out')) return;
      var x = mini.getAttribute('data-size'); state.open = null;
      if (i === 0) { renderItems(); setThemeOpt(SIZE_POS, x); } else { state.items[i].s = (x === state.size) ? null : x; render(); }
      focusPill(i);
    }
  });
  rows.addEventListener('keydown', function (e) {
    var d = e.target.closest && e.target.closest('.rwb-dot'); if (!d) return;
    var dir = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0; if (!dir) return;
    e.preventDefault();
    var row = d.closest('.rwb-item'), all = Array.prototype.slice.call(row.querySelectorAll('.rwb-dot')), k = all.indexOf(d), guard = 0;
    do { k = (k + dir + all.length) % all.length; } while (all[k].classList.contains('is-out') && ++guard < all.length);
    pickColour(+row.getAttribute('data-i'), +all[k].getAttribute('data-id'));
  });
  // Hovering a dot previews its name (some colours share a swatch colour, so the name matters).
  rows.addEventListener('mouseover', function (e) {
    var d = e.target.closest && e.target.closest('.rwb-dot'); if (!d) return;
    var row = d.closest('.rwb-item'), n = row.querySelector('[data-name]'), o = byId[+d.getAttribute('data-id')]; if (!o) return;
    n.classList.add('is-preview');
    n.innerHTML = esc(o.name) + (d.classList.contains('is-out') ? '<small>sold out in ' + esc(optLabel(sizeOf(+row.getAttribute('data-i')), fitOf(+row.getAttribute('data-i')))) + '</small>' : onSale(o) ? '<small>' + money(o.price) + ', on sale</small>' : '');
  });
  rows.addEventListener('mouseout', function (e) {
    var d = e.target.closest && e.target.closest('.rwb-dot'); if (!d) return;
    var row = d.closest('.rwb-item'); if (!row) return; var n = row.querySelector('[data-name]'), it = byId[state.items[+row.getAttribute('data-i')].c] || me;
    n.classList.remove('is-preview'); n.textContent = it.name;
  });
  rows.addEventListener('scroll', function (e) { if (e.target.classList && e.target.classList.contains('rwb-strip__track')) updateStrip(e.target); }, true);
  window.addEventListener('resize', function () { each(rows.querySelectorAll('.rwb-strip__track'), updateStrip); });
  rows.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var t = e.target.closest('.rwb-strip__track'); if (t) drag = { t: t, x: e.clientX, left: t.scrollLeft, moved: false };
  });
  window.addEventListener('pointermove', function (e) {
    if (!drag) return; var dx = e.clientX - drag.x;
    if (!drag.moved && Math.abs(dx) < 5) return;
    drag.moved = true; drag.t.classList.add('is-dragging'); drag.t.scrollLeft = drag.left - dx;
  });
  window.addEventListener('pointerup', function () {
    if (!drag) return;
    if (drag.moved) { suppressClick = true; setTimeout(function () { suppressClick = false; }, 0); }
    drag.t.classList.remove('is-dragging'); drag = null;
  });
  document.addEventListener('click', function (e) {
    if (!state.open || !e.target.closest || e.target.closest('.rwb-pop') || e.target.closest('[data-open]')) return;
    state.open = null; renderItems();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !state.open) return;
    var o = state.open; state.open = null; renderItems(); focusPill(o.i);
  });

  // Save every deal style and its tiers for the cart drawer nudge (assets/rw-bundle-nudge.js). Pages with the selector also set
  // the cart's deal flag, so whenever the discount can apply the nudge has the full list, including styles added from a collection page.
  try {
    if (cfg.map) { var fm = {}; (cfg.map.familyList || []).forEach(function (x) { fm[x[0]] = x[1]; });
      localStorage.setItem('rwb:map', JSON.stringify({ ladders: cfg.map.ladders, families: fm, stackOnSale: !!cfg.map.stackOnSale })); }
  } catch (e) {}

  // ---- Funnel: selector on the page -> cards actually on screen -> tier picked -> added ----
  track('rw_bundle_loaded', {});
  if ('IntersectionObserver' in window) {
    var seenIO = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { seenIO.disconnect(); track('rw_bundle_seen', {}); }
    }, { threshold: 0.5 });
    seenIO.observe($id('RwbTiers'));
  }

  // ---- Offer tag on the pinned Add to Cart bar. On phones the cards sit below the point where people tap Add to Cart,
  //      so the offer is shown where eyes already are; a tap jumps to the cards. Hidden once the cards are on screen or a tier is picked. ----
  var hint = null, cardsOnScreen = false;
  function hintUpdate() { if (hint) hint.hidden = cardsOnScreen || state.qty > 1; }
  (function () {
    var bar = document.getElementById('floatingATCBar'); if (!bar) return;
    var first = null; cfg.tiers.forEach(function (t) { if (!first && t.qty > 1 && t.pct > 0) first = t; }); if (!first) return;
    hint = document.createElement('button'); hint.type = 'button'; hint.className = 'rwb-hint';
    hint.innerHTML = '<span>Buy ' + first.qty + ', save ' + first.pct + '%</span><svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 4.5l4 4 4-4"/></svg>';
    bar.insertBefore(hint, bar.firstChild);
    hint.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation(); track('rw_bundle_hint_tap', {});
      var y = root.getBoundingClientRect().top + window.pageYOffset - 110; window.scrollTo({ top: y, behavior: 'smooth' });
      root.classList.add('is-flash'); setTimeout(function () { root.classList.remove('is-flash'); }, 1600);
    });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) { cardsOnScreen = entries[0].isIntersecting; hintUpdate(); }, { threshold: 0.35 }).observe($id('RwbTiers'));
  })();

  // ---- Start ----
  state.size = themeOpt(SIZE_POS); state.fit = HAS_FIT ? themeOpt(FIT_POS) : null;
  render();
  ensureGate();
  if ('requestIdleCallback' in window) window.requestIdleCallback(function () { ensureData(); }, { timeout: 4000 }); else setTimeout(function () { ensureData(); }, 2000);
})();
